<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'

import { Vector2, Mesh, RawShaderMaterial, SphereBufferGeometry, DoubleSide } from 'three'
// import { Refractor } from 'three/examples/jsm/objects/Refractor'
// import { FastBlurShader } from './FastBlurShader'
export default {
  name: 'GradientBG',
  mixins: [O3DG2],
  props: {
  },
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    // let RES_SIZE = 1024

    let scale = 2500

    this.$on('init', async () => {
      // let camera = this.ctx.camera
      // let screen = {
      // }
      // screen.width = camera.getFilmWidth() * scale
      // screen.height = camera.getFilmHeight() * scale
      let geo = new SphereBufferGeometry(scale, scale, 10, 10)
      let uniforms = {
        time: { value: 0 },
        sceneRect: { value: new Vector2(2, 2) }
      }
      let mat = new RawShaderMaterial({
        // eslint-disable-next-line
        vertexShader: require('raw-loader!./glsl/fbm.vs.glsl').default,
        // eslint-disable-next-line
        fragmentShader: require('raw-loader!./glsl/fbm.fs.glsl').default,
        uniforms,
        side: DoubleSide,
        transparent: true
      })

      let mesh = new Mesh(geo, mat)

      this.onResize(async () => {
        // let element = this.ctx.renderer.domElement
        // let elRect = element.getBoundingClientRect()
        uniforms.sceneRect.value = new Vector2(2, 2)
        // let screen = {}
        // screen.width = camera.getFilmWidth() * scale
        // screen.height = camera.getFilmHeight() * scale
        let geo = new SphereBufferGeometry(scale, scale, 10, 10)
        mesh.geometry = geo
      })

      this.o3d.children.forEach((v) => {
        this.o3d.remove(v)
      })
      this.o3d.add(mesh)

      this.onLoop(() => {
        mesh.material.uniforms['time'].value = window.performance.now() * 0.001
      })
    })
    this.$emit('init')
  },
  beforeDestroy () {
  }
}
</script>

<style>
</style>
